export default {
  user: null,
  areas: null,
  error: false,
  currentRoute: {
    parent: null,
    name: null
  }
};
